module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dYZYs"))).then(() => parcelRequire('ikE14'));